import { render, staticRenderFns } from "./ArbitriumReactIsland.vue?vue&type=template&id=590cc436&scoped=true"
import script from "./ArbitriumReactIsland.vue?vue&type=script&lang=js"
export * from "./ArbitriumReactIsland.vue?vue&type=script&lang=js"
import style0 from "./ArbitriumReactIsland.vue?vue&type=style&index=0&id=590cc436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590cc436",
  null
  
)

export default component.exports